module.exports = __webpack_public_path__ + "static/media/digilocker_kyc.cb48ed39.svg";